import React from 'react'
import { Route, IndexRoute, Redirect } from 'react-router'

import config from './config'
import GlobalLayoutContainer from './containers/GlobalLayoutContainer'
import HomePage from './pages/Home'
import BuildingPage from './pages/Building'
import ApartmentsPage from './pages/Apartments'
import NeighborhoodPage from './pages/Neighborhood'
import DeveloperPage from './pages/Developer'
import ApartmentStoryPage from './pages/ApartmentStory'
import AvailabilityPageContainer from './containers/AvailabilityPageContainer'
import ListingPageContainer from './containers/ListingPageContainer'
import NotFoundPage from './pages/NotFound'

/**
 * This file exports a function that returns our react app's routes.
 * The function takes as an argument a function that we'll run on every
 * page component to create a higher order component if necessary.
 */
/* eslint-disable react/display-name */
export default function(page, preloadedData) {
  return (
    <Route path={config.routerRoot} component={(props) => {
      return <GlobalLayoutContainer preloadedData={preloadedData} {...props} />
    }}>

      <IndexRoute component={page(HomePage)} />
      <Route path='building' component={page(BuildingPage)} />
      <Route path='apartments' component={page(ApartmentsPage)} />
      <Route path='neighborhood' component={page(NeighborhoodPage)} />
      <Route path='developer' component={page(DeveloperPage)} />
      <Route path='availability' component={page(AvailabilityPageContainer)} />
      <Route path='availability/:id' component={page(AvailabilityPageContainer)} />
      <Route path='listing' component={page(ListingPageContainer)} />
      <Redirect path='apartment-stories/tavi-gevinson' to='/' />
      <Redirect path='story-tavi-gevinson' to='/' />
      <Redirect path='apartment-stories' to='/' />
      {/* // <Redirect path='availability' to='https://www.twotreesny.com/apartments/300-ashland' /> */}
      {/* // <Route path='availability' component={() => window.location = 'https://www.twotreesny.com/apartments/300-ashland'}/> */}


      <Route path='broker/'>
        <IndexRoute component={page(HomePage)} />
        <Route path='building' component={page(BuildingPage)} />
        <Route path='apartments' component={page(ApartmentsPage)} />
        <Route path='neighborhood' component={page(NeighborhoodPage)} />
        <Route path='developer' component={page(DeveloperPage)} />
        <Route path='availability' component={page(AvailabilityPageContainer)} />
        <Route path='listing' component={page(ListingPageContainer)} />
        <Redirect path='apartment-stories/tavi-gevinson' to='/' />
        <Redirect path='story-tavi-gevinson' to='/' />
        <Redirect path='apartment-stories' to='/' />
      </Route>

      <Redirect path='broker' to='broker/' />

      {/* Redirects for old pages */}
      <Redirect path='contact-us' to='/' state={{'fromContact': true}} />

      <Route path='*' component={page(NotFoundPage)} />
    </Route>
  );
}


// WEBPACK FOOTER //
// ./client/routes.js